function initLoyaltyInfo() {
  // Init Variables
  const infoTabs = document.querySelectorAll('[data-omneo-info-tab]')
  const infoSections = document.querySelectorAll('[data-omneo-info-section]')

  if (!infoTabs.length || !infoSections.length) {
    console.warn('No Loyalty Info Tabs or Sections found')
    return
  }

  // set active=true on the first tab and section
  infoTabs[0].setAttribute('active', 'true')
  infoSections[0].setAttribute('active', 'true')

  // INIT - Set the active colour and disabled colour for each tab dynamically
  infoTabs.forEach((tab) => {
    const activeColour = tab.getAttribute('data-active-colour') || '#f3f4f6'
    const disabledColour = tab.getAttribute('data-disabled-colour') || '#e5e7eb'
    tab.style.backgroundColor = tab.getAttribute('active') === 'true' ? activeColour : disabledColour
    infoSections.forEach((section) => {
      if (section.dataset.omneoInfoSection === tab.dataset.omneoInfoTab) {
        section.style.backgroundColor = activeColour
      }
    })

    // Add event listener to each tab
    tab.addEventListener('click', () => {
      // Sets every tab to disabled and every colour to disabled to reset the colours
      infoTabs.forEach((x) => {
        x.setAttribute('active', 'false')
        x.style.backgroundColor = x.getAttribute('data-disabled-colour')
      })
      infoSections.forEach((section) => {
        section.setAttribute('active', 'false') // Resets the sections
        if (section.dataset.omneoInfoSection === tab.dataset.omneoInfoTab) {
          tab.style.backgroundColor = activeColour
          section.classList.remove('hidden')
          tab.setAttribute('active', 'true')
          section.setAttribute('active', 'true')
        } else {
          section.classList.add('hidden')
        }
      })
    })
  })
}

document.addEventListener('DOMContentLoaded', initLoyaltyInfo)
